<template>
  <div class="deposit-result">
    <div v-if="$slots.heading" class="deposit-result__heading">
      <slot name="heading"></slot>
    </div>

    <div v-if="$slots.icon" class="deposit-result__icon">
      <slot name="icon"></slot>
    </div>

    <div v-if="$slots.body" class="deposit-result__body">
      <slot name="body"></slot>
    </div>

    <div v-if="$slots.actions" class="deposit-result__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script src="./deposit-result.js"></script>
<style src="./deposit-result.scss" lang="scss"></style>
